import { Heading } from "@chakra-ui/react";
import React from "react";

const SectionHeading = ({ children, className, ...resProps }) => {
  return (
    <Heading size={"xl"} className={className} {...resProps}>
      {children}
    </Heading>
  );
};

export default SectionHeading;
